function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

var _templateObject;

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

import { BaseElement } from "./base-element.js";
import offerBoxStyles from "./offer-box-styles.js";
import { OfferPaymentMixin } from "./mixin/offer-payment-mixin.js";
import { ProductController } from "./product-display-controller.js";
import { quoteContext } from "./quote-context.js";
import { SelectedState } from "./selected-state.js";
import { provide } from "@lit/context";
import { css } from "lit";
import { property, state } from "lit/decorators.js";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;

var __decorateClass = function __decorateClass(decorators, target, key, kind) {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;

  for (var i = decorators.length - 1, decorator; i >= 0; i--) {
    if (decorator = decorators[i]) result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  }

  if (kind && result) __defProp(target, key, result);
  return result;
};

var _PackageToggleOfferElement = /*#__PURE__*/function (_OfferPaymentMixin) {
  _inherits(_PackageToggleOfferElement, _OfferPaymentMixin);

  var _super = _createSuper(_PackageToggleOfferElement);

  function _PackageToggleOfferElement() {
    var _this;

    _classCallCheck(this, _PackageToggleOfferElement);

    _this = _super.call(this);
    _this.quotes = [];
    _this.productController = new ProductController(_assertThisInitialized(_this), function () {
      var _a, _b, _c, _d, _e;

      _this.quoteForProductDisplay = (_a = _this.productController) == null ? void 0 : _a.value;

      if ((_c = (_b = _this.productController) == null ? void 0 : _b.value) == null ? void 0 : _c.offer_id) {
        _this.offerId = (_e = (_d = _this.productController) == null ? void 0 : _d.value) == null ? void 0 : _e.offer_id;
      }
    });
    return _this;
  }
  /**
   * @ignore
   */


  _createClass(_PackageToggleOfferElement, [{
    key: "offerId",
    get: function get() {
      var _this2 = this;

      var _a;

      var offerId = (_a = document.cookie.split("; ").find(function (row) {
        return row.split("=")[0] === _this2.offerIdCookieName;
      })) == null ? void 0 : _a.split("=")[1];
      return offerId;
    }
    /**
     * @ignore
     */
    ,
    set: function set(offerId) {
      document.cookie = "".concat(this.offerIdCookieName, "=").concat(offerId, ";max-age=604800;");
    }
    /**
     * @ignore
     */

  }, {
    key: "offerIdCookieName",
    get: function get() {
      return "vertical_insure_offer_id:" + this.product;
    }
  }, {
    key: "offerStateChangeHandler",
    value: function offerStateChangeHandler(e) {
      var _a, _b, _c;

      this.errors = [];
      var targetItem = e.target;
      var offers = (_a = this.shadowRoot) == null ? void 0 : _a.querySelectorAll("#offers *");

      if (_toConsumableArray(offers).some(function (el) {
        return el.quote == void 0;
      })) {
        return;
      }

      offers == null ? void 0 : offers.forEach(function (c) {
        var item = c;

        if (item.dataset.uniqueId != targetItem.dataset.uniqueId) {
          item.selectedState = SelectedState.UNKNOWN;
        }
      });
      offers = (_b = this.shadowRoot) == null ? void 0 : _b.querySelectorAll("#offers *");

      if (_toConsumableArray(offers).some(function (el) {
        return el.selectedState == SelectedState.ACCEPTED;
      })) {
        this.selectedState = SelectedState.ACCEPTED;
      }

      offers = (_c = this.shadowRoot) == null ? void 0 : _c.querySelectorAll("#offers *");

      if (_toConsumableArray(offers).every(function (el) {
        return el.selectedState == SelectedState.UNKNOWN;
      })) {
        this.selectedState = SelectedState.UNKNOWN;
      }

      var currentQuotes = [];
      var options = {
        detail: _toConsumableArray(offers).map(function (o) {
          var el = o;
          currentQuotes.push(el.quote);
          return {
            quote: el.quote,
            selectedState: SelectedState[el.selectedState]
          };
        }),
        bubbles: true,
        composed: true
      };
      this.quotes = currentQuotes;
      this.dispatchEvent(new CustomEvent("offer-state-change", options));

      if (this.debug) {
        console.debug("Fired offer-state-change event", options.detail);
      }
    }
  }, {
    key: "decline",
    value: function decline() {
      var _a;

      var offers = (_a = this.shadowRoot) == null ? void 0 : _a.querySelectorAll("#offers *");

      if (_toConsumableArray(offers).some(function (el) {
        return el.quote == void 0;
      })) {
        return;
      }

      offers == null ? void 0 : offers.forEach(function (c) {
        var item = c;
        item.selectedState = SelectedState.DECLINED;
      });
      this.selectedState = SelectedState.DECLINED;
      var options = {
        detail: _toConsumableArray(offers).map(function (o) {
          var el = o;
          return {
            quote: el.quote,
            selectedState: SelectedState[el.selectedState]
          };
        }),
        bubbles: true,
        composed: true
      };
      this.dispatchEvent(new CustomEvent("offer-state-change", options));

      if (this.debug) {
        console.debug("Fired offer-state-change event", options.detail);
      }
    }
  }, {
    key: "total",
    get: function get() {
      var _a;

      var offers = (_a = this.shadowRoot) == null ? void 0 : _a.querySelectorAll("#offers *");
      return _toConsumableArray(offers).reduce(function (value, o) {
        var el = o;
        return el.selectedState === SelectedState.ACCEPTED ? value + el.quote.total : value;
      }, 0);
    }
  }]);

  return _PackageToggleOfferElement;
}(OfferPaymentMixin(BaseElement));

_PackageToggleOfferElement.styles = [offerBoxStyles, css(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n      :host {\n        height: 100%;\n        width: 100%;\n        max-width: 950px;\n        margin-top: unset;\n      }\n\n      #multi-offer-wrapper {\n        margin-top: 10px;\n        display: flex;\n        flex-direction: column;\n        container-type: inline-size;\n      }\n\n      #multi-offer-wrapper #legal-disclaimer {\n        padding: 0px 4px;\n      }\n\n      #offers {\n        margin-top: unset;\n        display: flex;\n        align-items: stretch;\n        gap: 10px;\n      }\n\n      .decline-action {\n        outline: 1px solid var(--default-vi-border-color);\n        border-radius: var(--default-vi-border-radius);\n        padding: 16px;\n        background-color: var(--default-vi-bg-color);\n        margin-top: 10px;\n        margin-bottom: 10px;\n      }\n\n      .decline-action offer-accordion-header h1 {\n        font-size: var(--vi-multi-offer-header-font-size); \n        font-weight: bold;\n        margin: 0;\n      }\n\n      section#errors {\n        color: var(--default-vi-danger-color);\n        font-weight: bold;\n      }\n\n      section#errors p {\n        margin: 0;\n      }\n\n      payment-element {\n        margin-top: 20px;\n      }\n\n      @media (max-width: 830px) {\n        #offers {\n          flex-direction: column;\n        }\n      }\n    "])))];
var PackageToggleOfferElement = _PackageToggleOfferElement;

__decorateClass([property({
  attribute: "product"
})], PackageToggleOfferElement.prototype, "product", 2);

__decorateClass([property({
  attribute: "customer-first-name"
})], PackageToggleOfferElement.prototype, "customerFirstName", 2);

__decorateClass([property({
  attribute: "customer-last-name"
})], PackageToggleOfferElement.prototype, "customerLastName", 2);

__decorateClass([property({
  attribute: "customer-email-address"
})], PackageToggleOfferElement.prototype, "customerEmailAddress", 2);

__decorateClass([property({
  attribute: "customer-street-address"
})], PackageToggleOfferElement.prototype, "customerStreetAddress", 2);

__decorateClass([property({
  attribute: "customer-state"
})], PackageToggleOfferElement.prototype, "customerState", 2);

__decorateClass([property({
  attribute: "customer-city"
})], PackageToggleOfferElement.prototype, "customerCity", 2);

__decorateClass([property({
  attribute: "customer-postal-code"
})], PackageToggleOfferElement.prototype, "customerPostalCode", 2);

__decorateClass([provide({
  context: quoteContext
}), state()], PackageToggleOfferElement.prototype, "quoteForProductDisplay", 2);

__decorateClass([state()], PackageToggleOfferElement.prototype, "quotes", 2);

export { PackageToggleOfferElement };